import { combineReducers } from '@reduxjs/toolkit';
import completionRateReducer from './completionRateSlice';
import completionRateProfileReducer from './completionRateProfileSlice';

// 合并 completionRate 模块下的所有 reducer
const completionRateStore = combineReducers({
  // 统一的 completionRate slice（使用 switchPayload）
  completionRate: completionRateReducer,
  // 护理部完成率明细 slice
  completionRateProfile: completionRateProfileReducer,
  // 保留原有的独立 slice（向后兼容）
});

export default completionRateStore;

